<div [attr.inert]="isSaving ? '' : null" [attr.aria-busy]="isSaving">
  <features
    translate
    *ngIf="featureBase"
    [isPortalExists]="isPortalExists"
    [featureBase]="featureBase"
    [supplierChecked]="supplierChecked"
  ></features>
</div>

<div class="action-btns-wrapper">
  <button
    *ngIf="!(roleId === 1 && isPortalExists)"
    type="button"
    class="btn btn-primary feature-save-button"
    [disabled]="isSaving || !businessDetails || !featureBase"
    [attr.aria-busy]="isSaving"
    (click)="saveFeature()"
  >
    <i
      [class]="isSaving ? 'pi pi-spinner pi-spin' : 'pi pi-save'"
      aria-hidden="true"
    ></i>
    <span class="feature-save-label">
      <span [class.is-hidden]="isSaving" [attr.aria-hidden]="isSaving">{{
        "SAVE" | translate
      }}</span>
      <span [class.is-hidden]="!isSaving" [attr.aria-hidden]="!isSaving">{{
        "BUSINESS_FEATURE_SAVE.SAVING" | translate
      }}</span>
    </span>
  </button>
  <button
    *ngIf="isAdmin || isPortal"
    type="button"
    class="btn btn-outline-primary"
    [disabled]="isSaving"
    (click)="rModeCheckFeature()"
  >
    <span translate>R</span>
  </button>
  <span
    class="feature-save-status"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <span *ngIf="isSaving">{{
      "BUSINESS_FEATURE_SAVE.SAVING" | translate
    }}</span>
    <span *ngIf="!isSaving && saveStatus === 'success'" class="text-success">
      <i class="pi pi-check-circle" aria-hidden="true"></i>
      {{ "BUSINESS_FEATURE_SAVE.SUCCESS" | translate }}
    </span>
  </span>
  <span class="feature-save-status text-danger" role="alert" aria-atomic="true">
    <span *ngIf="!isSaving && saveStatus === 'error'">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      {{ "BUSINESS_FEATURE_SAVE.ERROR" | translate }}
    </span>
  </span>
</div>
